import classNames from "classnames";
import { Checkbox } from "components/DesignSystem/Checkbox/Checkbox";
import { useModal } from "hooks/useModal";
import { useContext } from "react";
import {
  CheckoutModalPropsContext,
  RecurringPaymentConsent,
} from "./CheckoutModalPropsContext";
import { ConditionalLink } from "components/conditionalLink";

export const RecurringPaymentPermission = () => {
  const propsContext = useContext(CheckoutModalPropsContext);
  const {
    isRecurringPaymentConsentRequire,
    isRecurringPaymentConsent,
    setRecurringPaymentConsent,
    isRecurringPaymentConsentError,
  } = (propsContext as RecurringPaymentConsent) || {};

  const handleRecurringPaymentConsentUpdate = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    e.stopPropagation();
    setRecurringPaymentConsent(e.target.checked);
  };

  if (isRecurringPaymentConsentRequire) {
    return (
      <div>
        <div
          className={classNames(
            "t-flex t-gap-2 t-items-start t-p-3.5 t-rounded-md t-border t-border-solid t-bg-surface-purple",
            {
              "t-border-red-40": isRecurringPaymentConsentError,
              "t-border-purple-20": !isRecurringPaymentConsentError,
            }
          )}
        >
          <Checkbox
            onChange={handleRecurringPaymentConsentUpdate}
            checked={isRecurringPaymentConsent}
            name="isRecurringPaymentConsent"
          />
          <label
            htmlFor="isRecurringPaymentConsent"
            className="-t-mt-1 t-text-body-sm t-italic"
          >
            <span className="t-text-text-30">
              By checking this box, I authorise Inkle to collect payments for
              the recurring yearly items in this cart. Any available Inkle
              credits will be applied unless paid manually. I have read and
              agree to the{" "}
              <ConditionalLink to="https://www.inkle.ai/terms-of-service">
                terms and conditions
              </ConditionalLink>
              .
              <span>
                {isRecurringPaymentConsentError && (
                  <>
                    <br />
                    <div className="t-text-red t-text-body-sm">
                      You must authorise this recurring payment to proceed.
                    </div>
                  </>
                )}
              </span>
            </span>
          </label>
        </div>
      </div>
    );
  }

  return null;
};
